import { colors } from "../../data/colors";

const Container = ({
  text,
  main,
  align = "center",
}: {
  text: string;
  main: boolean;
  align: "left" | "right" | "center" | "justify";
}) => (
  <div
    style={{
      textAlign: align,
      fontSize: 16,
      maxWidth: 350,
      fontWeight: main ? "bold" : "normal",
      marginBottom: 10,
      color: main ? colors.blue : colors.black,
      whiteSpace: "pre-line",
    }}
  >
    {text}
  </div>
);

export default function WriteText({
  info,
  main,
  align = "center",
}: {
  info: string | Array<string>;
  main: boolean;
  align?: "left" | "right" | "center" | "justify";
}) {
  return (Array.isArray(info) || typeof info === "string") &&
    info.length > 0 ? (
    <div className="horizontal">
      {Array.isArray(info) ? (
        <table>
          <tbody>
            {info.map((e, index) => (
              <tr key={index}>
                <td>
                  <Container text={e} main={main} align={align} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Container text={info} main={main} align={align} />
      )}
    </div>
  ) : (
    <></>
  );
}
